





































































    import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
    import TableField from '@/types/TableField';
    import EntityReference from '@/types/EntityReference';
    import { BTable, BButton, BIconPencil, BIconTrash, BFormGroup, BCol, BRow, BFormCheckboxGroup, BCard, BSpinner } from 'bootstrap-vue';

    @Component({
        components: {
            'b-table': BTable,
            'b-card': BCard,
            'b-btn': BButton,
            'b-row': BRow,
            'b-col': BCol,
            'b-form-group': BFormGroup,
            'b-form-checkbox-group': BFormCheckboxGroup,
            'b-icon-pencil': BIconPencil,
            'b-icon-trash': BIconTrash,
            'b-spinner': BSpinner
        }
    })
	export default class UserProjectList extends Vue {
        @Prop() projects!: UserProjectListItem[];
        @Prop() roles!: EntityReference[];

        isBusy = false;
        localProjects: UserProjectListItem[] = [];

        fields: TableField[] = [
			{
                key: 'name',
                label: 'fields.project',
                headerTitle: 'Name',
                sortable: true,
                thStyle: '',
                thClass: 'unselectable text-nowrap',
                tdClass: 'text-nowrap',
                formatter: null
            },
            {
                key: 'roles',
                label: 'fields.roles',
                headerTitle: 'Roles',
                sortable: false,
                thStyle: '',
                thClass: 'unselectable text-nowrap',
                tdClass: 'text-wrap',
                formatter: null
            },
            {
                key: 'actions',
                label: '',
                headerTitle: '',
                sortable: false,
                thStyle: 'width: 100px',
                thClass: '',
                tdClass: 'pl-3 pr-1',
                formatter: null
            }
        ];

        @Watch('projects')
        getSelectedRoles(newVal: UserProjectListItem[]) {
            if (this.localProjects.length === 0) {
                this.localProjects = newVal;
                this.localProjects.forEach(p => p.selectedRoles = p.roles.map(r => r.id));
            }
        }

        mounted() {
            this.isBusy = false;
        }

        deleteProject(id: string) {
            this.$bvModal.msgBoxConfirm(this.$t('modal.confirmUserProjectDeleteMessage') as string, {
                title: this.$t('modal.confirmUserProjectDeleteTitle') as string,
                centered: true,
                buttonSize: 'sm',
                okTitle: this.$t('modal.confirmOkTitle') as string,
                cancelTitle: this.$t('modal.confirmCancelTitle') as string
            })
            .then(value => {
                if (value) {
                    this.localProjects.splice(this.localProjects.findIndex(lp => lp.id === id), 1);
                }
            })
            .catch(error => {
                console.error(error);
            });
        }

        userInProjectRole(roles: EntityReference[], roleId: string) {
            return (roles.filter((r) => { return r.id === roleId; }).length > 0);
        }

        onRolesChange(e: (string | null)[], project: UserProjectListItem) {
            this.localProjects.forEach((p) => {
                if (p.id === project.id) {
                    p.selectedRoles = e;
                    p.roles = [];
                    p.selectedRoles.forEach((sr) => {
                        const r = this.roles.filter((r) => { return r.id === sr; });
                        if (r.length > 0) {
                            p.roles.push(r[0]);
                        }
                    });
                    this.$emit('user-project-change', this.localProjects);
                    return;
                }
            });
        }
	}

    interface UserProjectListItem {
        id: string;
        name: string;
        roles: EntityReference[];
        actions: string;
        selectedRoles: (string | null)[]; 
    }
